import React, { Component, memo } from "react";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import "moment-timezone";
// import readXlsxFile from "read-excel-file";

import EditBtnCellRenderer from "./editBtnCellRenderer";
import RequisitionPdfRenderer from "./requisitionPdfRenderer";
import ResultPdfRenderer from "./resultPdfRenderer";
import CreateToxicologyRequisition from "./createToxicologyRequisition";

import { getRequisitions } from "../../../services/clinicPortalServices/orderSearchService";
import { bulkDownloadZipForPDF, releaseResults } from "../../../services/clinicPortalServices/orderEditService";
import { fetchFacilitiesForOrders } from "../../../services/clinicPortalServices/facilityServices";
import { fetchDiagnosisCodesList } from "../../../services/clinicPortalServices/requisitionService";
import { fetchMedications } from "../../../services/clinicPortalServices/medicationService";
import { serviceConstants, auditEnums } from "../../../services/common/constants";
import {
    getUserRole,
    processCellForClipboard,
    defaultExcelExportParams,
    abortApiCalls,
    releaseApiCalls,
    getUserDetails,
    isAllowedReducedGridView
} from "../../../services/common/util";
import RequisitionSearchMenu from "./requisitionSearchMenu";
import PatientBtnCellRenderer from "../orders/clinicOrderGrid/patientBtnCellRenderer";
import { getViewSettings, saveViewDefault } from "../../../services/clinicPortalServices/userViewSettings";
import { orderStatuses, settingConstants } from "../../../services/common/optionsData";
import toastr from "toastr";
import { getCompanyWithFacility } from "../../../services/clinicPortalServices/companyServices";
import _ from "lodash";
import SampleTrackingCellRenderer from "../orders/clinicOrderGrid/sampleTrackingCellRenderer";
import { getPlateList } from "../../../services/limsPortalServices/plateService";
import CancelReasonComponent from "../requisitionsNew/clinicRequisitionNewGrid/CancelReasonComponent";
import SymptomRenderer from "../orders/clinicOrderGrid/symptomRenderer";
import NoticeHistoryCellRenderer from "../orders/clinicOrderGrid/noticeHistoryCellRenderer";
import { createAudit } from "../../../services/clinicPortalServices/auditService";
import { getAllTests } from "../../../services/clinicPortalServices/testService";
import { ThemeContext } from "../../../theme/ThemeProvider";
import store from "../../../redux/store";
import actions from "../../../redux/actions";
import { bindActions } from "redux-zero/utils";
import { colorSchemeDark, colorSchemeLight, themeQuartz } from "ag-grid-community";

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

const boundActions = bindActions(actions, store);

export const RequisitionGridContext = React.createContext();

class ToxicologyOrderGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            paginationPageSize: 20,
            quickFilterText: "",
            isArchived: false,
            isReducedGridView: true,
            user_role: getUserRole(),
            searchFilters: {
                facility_id: [],
                from_date: moment().format("YYYY-MM-DD") + "T00:00",
                to_date: moment().add(1, "days").format("YYYY-MM-DD") + "T00:00",
                dateRange: "today"
            },
            selectedStatuses: orderStatuses,
            gridName: "Default",
            pageSize: "",
            columnDefs: [
                {
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionCurrentPageOnly: true,
                    filter: false,
                    suppressMenu: true,
                    width: 50,
                    resizable: false,
                    pinned: "left"
                },
                {
                    headerName: 'Actions',                    
                    autoSize: true,
                    minWidth: 220,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: "Requisition Information",
                    children: [
                        {
                            headerName: "Requisition",
                            minWidth: 120,
                            resizable: true,
                            field: "lab_order_id"
                        },
                        {
                            headerName: "Status",
                            minWidth: 140,
                            resizable: true,
                            field: "status"
                        },
                        {
                            headerName: "Patient Name",
                            minWidth: 120,
                            resizable: true,
                            valueGetter: function addColumns(params) {
                                if (params.data.patient_id) {
                                    return params.data.patient_id.first_name + " " + params.data.patient_id.last_name;
                                } else {
                                    return "";
                                }
                            },
                            cellRenderer: "patientBtnCellRenderer"
                        },
                        {
                            headerName: "DOB",
                            minWidth: 150,
                            valueGetter: function addColumns(params) {
                                return params.data.patient_id && params.data.patient_id.date_of_birth
                                    ? moment(params.data.patient_id.date_of_birth, "YYYY-MM-DD").format("MM/DD/YYYY")
                                    : "";
                            },
                            field: "patient_id.date_of_birth",
                            columnGroupShow: "open",
                            resizable: true
                        },
                        {
                            headerName: "MRN",
                            minWidth: 150,
                            field: "patient_id.mrn",
                            columnGroupShow: "open",
                            resizable: true
                        },
                        {
                            headerName: "Tests",
                            minWidth: 100,
                            resizable: true,
                            valueGetter: (params) => {
                                let testCountString = "";
                                let panelCountString = "";
                                let testCount = params.data.orderIds.filter(
                                    (item) => item.order_type === "single"
                                ).length;
                                if (testCount > 0) {
                                    testCountString = testCount + " Test" + (testCount > 1 ? "s" : "");
                                }
                                let panelCount = params.data.orderIds.filter(
                                    (item) => item.order_type === "panel"
                                ).length;
                                if (panelCount > 0) {
                                    let panelTestCount = params.data.orderIds
                                        .filter((item) => item.order_type === "panel")
                                        .map((item) => item.orderIds.length)
                                        .reduce((a, b) => a + b, 0);
                                    panelCountString =
                                        panelCount +
                                        " Panel" +
                                        (panelCount > 1 ? "s" : "") +
                                        " (" +
                                        panelTestCount +
                                        " Test" +
                                        (panelTestCount > 1 ? "s" : "") +
                                        ")";
                                }
                                return [testCountString, panelCountString].filter(Boolean).join(", ") || "No Tests";
                            }
                        },
                        {
                            headerName: "Sample IDs",
                            minWidth: 180,
                            field: "test_info.sample",
                            cellRenderer: memo((params) => {
                                let sampleIds = [];
                                params.data.orderIds.map((item) => {
                                    if (!sampleIds.includes(item.test_info.sample)) {
                                        sampleIds.push(item.test_info.sample);
                                    }
                                    return null;
                                });
                                if (params.data.test_info && params.data.test_info.sample) {
                                    return (
                                        <div>
                                            {sampleIds.length} ({sampleIds.join(", ")})
                                        </div>
                                    );
                                }
                                return <div></div>;
                            }),
                            resizable: true
                        },
                        {
                            headerName: "Driver License",
                            minWidth: 150,
                            field: "patient_id.driver_license",
                            resizable: true
                        },
                        {
                            headerName: "Requisition PDF",
                            minWidth: 150,
                            field: "requisition_pdf_path",
                            cellRenderer: "requisitionPdfRenderer",
                            resizable: true
                        },
                        {
                            headerName: "Result PDF",
                            minWidth: 150,
                            field: "results.pdf_path",
                            cellRenderer: "resultPdfRenderer",
                            resizable: true
                        },
                        {
                            headerName: "Facility",
                            minWidth: 150,
                            resizable: true,
                            field: "facility_id.name"
                        },
                        {
                            headerName: "Physician",
                            minWidth: 150,
                            resizable: true,
                            valueGetter: function addColumns(params) {
                                if (params.data.provider) {
                                    return params.data.provider.first_name + " " + params.data.provider.last_name;
                                } else {
                                    return "";
                                }
                            }
                        },
                        {
                            colId: "collected_date",
                            headerName: "Specimen Collected Date",
                            minWidth: 200,
                            resizable: true,
                            field: "test_info.collected",
                            cellRenderer: function (params) {
                                return params.data.test_info && params.data.test_info.collected
                                    ? moment(params.data.test_info.collected, "YYYYMMDDHHmmss").format(
                                          "MM/DD/YYYY hh:mm A"
                                      )
                                    : "";
                            },
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Collector Name",
                            field: "test_info.collector_name",
                            minWidth: 200,
                            resizable: true,
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Diagnosis Code",
                            minWidth: 150,
                            resizable: true,
                            valueGetter: function addColumns(params) {
                                if (params.data.diagnosis_code && params.data.diagnosis_code.length) {
                                    return params.data.diagnosis_code.join(", ");
                                } else {
                                    return "";
                                }
                            },
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Passport",
                            minWidth: 150,
                            resizable: true,
                            field: "patient_id.passport",
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Is HL7?",
                            minWidth: 100,
                            resizable: true,
                            valueGetter: function addColumns(params) {
                                return params.data.is_HL7_requisition ? "YES" : "";
                            }
                        },
                        {
                            headerName: "Is VIP Order?",
                            minWidth: 100,
                            resizable: true,
                            valueGetter: function addColumns(params) {
                                return params.data.is_vip_order ? "YES" : "NO";
                            }
                        },
                        {
                            headerName: "Sample Tracking",
                            minWidth: 150,
                            resizable: true,
                            cellRenderer: "sampleTrackingCellRenderer",
                            valueGetter: (params) => {
                                if (params.data.sample_tracking && params.data.sample_tracking.length) {
                                    let eventName =
                                        params.data.sample_tracking[params.data.sample_tracking.length - 1].eventName;
                                    if (eventName === "IMPORT - FOR RETEST") {
                                        if (
                                            ["Positive SARS-CoV-2", "SARS-CoV-2 POSITIVE"].includes(
                                                params.data.sample_tracking[params.data.sample_tracking.length - 1]
                                                    .result
                                            )
                                        ) {
                                            eventName += " (Positive)";
                                        } else {
                                            eventName += " (Inconclusive / Invalid)";
                                        }
                                    }
                                    return eventName;
                                } else {
                                    return "No Info";
                                }
                            }
                        },
                        {
                            headerName: "Patient Symptoms",
                            resizable: true,
                            minWidth: 150,
                            field: "symptoms",
                            cellStyle: { textAlign: "center" },
                            cellRenderer: "symptomRenderer"
                        },
                        {
                            headerName: "Order Notice History",
                            resizable: true,
                            minWidth: 150,
                            field: "noticeHistory",
                            cellStyle: { textAlign: "center" },
                            cellRenderer: "noticeHistoryCellRenderer",
                            valueGetter: (params) => {
                                if (params.data.noticeHistory && params.data.noticeHistory.length) {
                                    return (
                                        params.data.noticeHistory.length +
                                        " Log" +
                                        (params.data.noticeHistory.length > 1 ? "s" : "")
                                    );
                                } else {
                                    return "No History";
                                }
                            }
                        },
                        {
                            headerName: "Is Cancelled?",
                            minWidth: 100,
                            resizable: true,
                            field: "is_cancel",
                            valueGetter: function addColumns(params) {
                                return params.data.is_cancel ? "YES" : "NO";
                            }
                        },
                        {
                            headerName: "Reason for cancellation",
                            minWidth: 100,
                            resizable: true,
                            field: "cancel_reason",
                            cellStyle: { textAlign: "center" },
                            cellRenderer: "CancelReasonComponent"
                        }
                    ]
                },
                {
                    headerName: "Insurance Information",
                    children: [
                        {
                            headerName: "YES/NO",
                            resizable: true,
                            minWidth: 100,
                            valueGetter: function addColumns(params) {
                                if (params.data.patient_insurance_id && params.data.patient_insurance_id._id) {
                                    return "YES";
                                } else {
                                    return "NO";
                                }
                            }
                        },
                        {
                            headerName: "Insurance Provider",
                            resizable: true,
                            minWidth: 150,
                            field: "patient_insurance_id.insurance_provider",
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Insurance Member ID",
                            resizable: true,
                            minWidth: 150,
                            field: "patient_insurance_id.insured_member_id",
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Insurance Group Number",
                            resizable: true,
                            minWidth: 150,
                            field: "patient_insurance_id.insured_group_number",
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Relation to Insured",
                            resizable: true,
                            minWidth: 150,
                            field: "patient_insurance_id.relation_to_insured",
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Insurance Holder Name",
                            resizable: true,
                            minWidth: 150,
                            valueGetter: function addColumns(params) {
                                if (
                                    params.data.patient_insurance_id &&
                                    params.data.patient_insurance_id.insured_first_name
                                ) {
                                    return (
                                        params.data.patient_insurance_id.insured_first_name +
                                        " " +
                                        params.data.patient_insurance_id.insured_last_name
                                    );
                                }
                            },
                            columnGroupShow: "open"
                        },
                        {
                            headerName: "Social Security Number",
                            resizable: true,
                            minWidth: 150,
                            field: "patient_insurance_id.social_security_number",
                            columnGroupShow: "open"
                        }
                    ]
                }
            ],
            components: {
                editBtnCellRenderer: EditBtnCellRenderer,
                requisitionPdfRenderer: RequisitionPdfRenderer,
                resultPdfRenderer: ResultPdfRenderer,
                patientBtnCellRenderer: PatientBtnCellRenderer,
                sampleTrackingCellRenderer: SampleTrackingCellRenderer,
                CancelReasonComponent: CancelReasonComponent,
                symptomRenderer: SymptomRenderer,
                noticeHistoryCellRenderer: NoticeHistoryCellRenderer
            },
            paginationNumberFormatter: function (params) {
                return "[" + params.value.toLocaleString() + "]";
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true,
                resizable: true
            },
            rowClassRules: {
                "cancelled-requisition": function (params) {
                    return params.data.is_cancel;
                },
                "on-hold-item": function (params) {
                    return params.data.status === "On Hold";
                },
                "archived-order": function (params) {
                    return params.data.status === "Archived";
                },
                "passed-24hours-requisition": function (params) {
                    return (
                        !params.data.is_cancel &&
                        params.data.passed_24hours &&
                        !(
                            params.data.sample_tracking &&
                            params.data.sample_tracking.filter((item) => item.eventName === "ACCESSIONED").length
                        )
                    );
                }
            },
            rowData: [],
            context: { componentParent: this },
            excelStyles: [
                {
                    id: "header",
                    interior: {
                        color: "#aaaaaa",
                        pattern: "Solid"
                    }
                },
                {
                    id: "body",
                    interior: {
                        color: "#dddddd",
                        pattern: "Solid"
                    }
                }
            ],
            facilities: [],
            allFacilities: [],
            showCreateToxicologyRequisition: false,
            plateList: [],
            tests: [],
            testIds: [],
            allDiagnosisCodes: []
        };

        getPlateList().then((res) => {
            if (res && res.data) {
                this.setState({ plateList: res.data });
            }
        });
        getAllTests({ type: "all" }).then((res) => {
            if (res && res.data) {
                let testIds = res.data.map((test) => {
                    return test._id;
                });
                this.testIds = testIds;
                this.setState({ tests: res.data, testIds: testIds }, () => {
                    this.loadFacilities(this.state.isArchived);
                    this.loadAllFacilities();
                });
            }
        });

        // Fetch diagnosis codes
        fetchDiagnosisCodesList()
            .then((res) => {
                if (res && res.data) {
                    this.setState({ allDiagnosisCodes: res.data });
                }
            })
            .catch((error) => {
                console.error("Error loading diagnosis codes:", error);
            });

        fetchMedications()
            .then((res) => {
                if (res.data && res.data) {
                    this.setState({
                        medicationOptions: res.data
                    });
                }
            })
            .catch((error) => {
                console.error("Error loading medications:", error);
            });
    }

    loadAllFacilities = () => {
        fetchFacilitiesForOrders().then((res) => {
            this.setState({ allFacilities: res.data });
        });
    };
    loadFacilities = (isArchived) => {
        let filters = this.state.searchFilters;
        let facilities = this.state.facilities;
        let isAllFacilities = false;
        if (
            filters.facility_id.length > 0 &&
            filters.facility_id.length === facilities.length &&
            facilities.length > 0
        ) {
            isAllFacilities = true;
        }
        if (window.localStorage.getItem("FROM_DATE_RANGE")) {
            filters.from_date = window.localStorage.getItem("FROM_DATE_RANGE");
        }
        if (window.localStorage.getItem("TO_DATE_RANGE")) {
            filters.to_date = window.localStorage.getItem("TO_DATE_RANGE");
        }

        getCompanyWithFacility(isArchived).then((response) => {
            let facilityIds = [];
            facilities = response.data;
            if (facilities.length > 0) {
                facilities.map((fac) => {
                    facilityIds.push(fac._id);
                    return null;
                });
                this.facilityIds = facilityIds;
                filters.facility_id = facilityIds;
            }
            if (
                !isAllFacilities &&
                window.localStorage.getItem("FACILITY_ID") &&
                JSON.parse(window.localStorage.getItem("FACILITY_ID")).length
            ) {
                filters.facility_id = JSON.parse(window.localStorage.getItem("FACILITY_ID"));
            }
            this.setDateRange(filters);
            this.setState(
                {
                    searchFilters: filters,
                    facilities: facilities
                },
                () => {
                    this.loadGridData();
                }
            );
        });
    };

    updateDateRange = (dateRange) => {
        let filters = this.state.searchFilters;
        if (filters.dateRange !== dateRange) {
            switch (dateRange) {
                case "today":
                    filters.to_date = moment().add(1, "days").format("YYYY-MM-DD") + "T00:00";
                    filters.from_date = moment().format("YYYY-MM-DD") + "T00:00";
                    filters.dateRange = dateRange;
                    break;
                case "week":
                    filters.to_date = moment().add(1, "days").format("YYYY-MM-DD") + "T00:00";
                    filters.from_date = moment().startOf("week").format("YYYY-MM-DD") + "T00:00";
                    filters.dateRange = dateRange;
                    break;
                case "month":
                    filters.to_date = moment().add(1, "days").format("YYYY-MM-DD") + "T00:00";
                    filters.from_date = moment().startOf("month").format("YYYY-MM-DD") + "T00:00";
                    filters.dateRange = dateRange;
                    break;
                default:
                    break;
            }
            this.setState({ searchFilters: filters });
            if (dateRange !== "custom") {
                this.loadGridData();
            }
        }
    };

    setDateRange = (searchFilters) => {
        if (moment(searchFilters.to_date).format("YYYY-MM-DD") === moment().add(1, "days").format("YYYY-MM-DD")) {
            if (moment(searchFilters.from_date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
                searchFilters.dateRange = "today";
            } else if (
                moment(searchFilters.from_date).format("YYYY-MM-DD") === moment().startOf("week").format("YYYY-MM-DD")
            ) {
                searchFilters.dateRange = "week";
            } else if (
                moment(searchFilters.from_date).format("YYYY-MM-DD") === moment().startOf("month").format("YYYY-MM-DD")
            ) {
                searchFilters.dateRange = "month";
            } else {
                searchFilters.dateRange = "custom";
            }
        } else {
            searchFilters.dateRange = "custom";
        }
    };

    handleDateFiltersChange = (dateTime, type) => {
        let filters = this.state.searchFilters;
        let filterIsValid = true;
        if (type === "from_date") {
            if (moment(filters.to_date).isAfter(dateTime)) {
                filters.from_date = dateTime;
                window.localStorage.setItem("FROM_DATE_RANGE", filters.from_date);
                window.localStorage.setItem("TO_DATE_RANGE", filters.to_date);
            } else {
                filterIsValid = false;
            }
        } else {
            if (moment(dateTime).isAfter(filters.from_date)) {
                filters.to_date = dateTime;
                window.localStorage.setItem("FROM_DATE_RANGE", filters.from_date);
                window.localStorage.setItem("TO_DATE_RANGE", filters.to_date);
            } else {
                filterIsValid = false;
            }
        }
        if (filterIsValid) {
            this.setDateRange(filters);
            this.setState({ searchFilters: filters });
            this.loadGridData();
        }
    };

    handleFiltersChange = (e) => {
        let filters = this.state.searchFilters;
        switch (e.target.name) {
            case "facility_id": {
                let { facilities } = this.state;
                let facilityIdChanged = [],
                    isAdded = false,
                    facilitiesIn = [],
                    facilityIdsTemp = [];
                let newFacilityIds = e.target.value;
                if (e.target.value.includes("all")) {
                    if (filters.facility_id.length === facilities.length) {
                        filters.facility_id = [];
                    } else {
                        filters.facility_id = _.cloneDeep(this.facilityIds);
                    }
                } else {
                    if (filters.facility_id.length > newFacilityIds.length) {
                        facilityIdChanged = filters.facility_id.find((val) => !newFacilityIds.includes(val));
                    } else {
                        facilityIdChanged = newFacilityIds.find((val) => !filters.facility_id.includes(val));
                        isAdded = true;
                    }
                    let facilityChanged = facilities.find((facility) => facility._id === facilityIdChanged);
                    facilityIdsTemp = _.cloneDeep(filters.facility_id);
                    // If company is changed
                    if (facilityChanged.type === "company") {
                        let companyChanged = facilityChanged;
                        facilities.forEach((fac) => {
                            if (fac.parent_id === companyChanged._id) {
                                facilitiesIn.push(fac._id);
                            }
                        });
                        let index = facilityIdsTemp.indexOf(companyChanged._id);
                        if (facilitiesIn.length > 0) {
                            // If company is selected
                            if (isAdded) {
                                // Add company Id
                                facilityIdsTemp.push(companyChanged._id);
                                // Add facility Ids
                                facilitiesIn.forEach((facId) => {
                                    if (!facilityIdsTemp.includes(facId)) {
                                        facilityIdsTemp.push(facId);
                                    }
                                });
                            } else {
                                // If company is unselected
                                // Remove company Id
                                if (index > -1) {
                                    facilityIdsTemp.splice(index, 1);
                                }
                                facilitiesIn.forEach((facId) => {
                                    let index = facilityIdsTemp.indexOf(facId);
                                    if (index > -1) {
                                        facilityIdsTemp.splice(index, 1);
                                    }
                                });
                            }
                        } else {
                            isAdded ? facilityIdsTemp.push(companyChanged._id) : facilityIdsTemp.splice(index, 1);
                        }
                    } else {
                        // If facility is changed
                        let companyId = facilityChanged.parent_id;
                        let facilitiesIn = [];
                        facilities.forEach((fac) => {
                            if (fac.parent_id === companyId) {
                                facilitiesIn.push(fac._id);
                            }
                        });
                        // If facility Id is selected
                        if (isAdded) {
                            // Add facility Id
                            facilityIdsTemp.push(facilityChanged._id);
                            if (!filters.facility_id.includes(companyId)) {
                                facilityIdsTemp.push(companyId);
                            }
                        } else {
                            // If facility Id is unselected
                            // Remove facility Id
                            let index = facilityIdsTemp.indexOf(facilityChanged._id);
                            if (index > -1) {
                                facilityIdsTemp.splice(index, 1);
                            }
                            // Remove company Id
                            let facilitiesInFilters = [];
                            facilitiesIn.forEach((fac) => {
                                if (facilityIdsTemp.includes(fac)) {
                                    facilitiesInFilters.push(fac);
                                }
                            });
                            if (facilitiesInFilters.length === 0) {
                                index = facilityIdsTemp.indexOf(companyId);
                                if (index > -1) {
                                    facilityIdsTemp.splice(index, 1);
                                }
                            }
                        }
                    }
                    filters.facility_id = _.cloneDeep(facilityIdsTemp);
                }
                window.localStorage.setItem("FACILITY_ID", JSON.stringify(filters.facility_id));
                this.setState({ searchFilters: filters }, () => {
                    this.loadGridData();
                });
                break;
            }
            case "testIds": {
                let testIds = this.state.testIds;
                if (e.target.value.includes("all")) {
                    if (testIds.length === this.state.tests.length) {
                        testIds = [];
                    } else {
                        testIds = _.cloneDeep(this.testIds);
                    }
                } else {
                    testIds = e.target.value;
                }
                this.setState({ testIds: testIds }, () => {
                    this.loadGridData();
                });
                break;
            }
            case "selectedStatuses": {
                if (e.target.value.includes("all")) {
                    if (this.state.selectedStatuses.length === orderStatuses.length) {
                        this.setState({ selectedStatuses: [] });
                    } else {
                        this.setState({ selectedStatuses: orderStatuses });
                    }
                } else {
                    this.setState({ selectedStatuses: e.target.value });
                }
                break;
            }
            default:
                break;
        }
    };

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridSchema();
    };

    checkRealFacilities = (searchFilters) => {
        let realFacilities = [];
        searchFilters.facility_id.map((facilityId) => {
            if (this.state.facilities.find((facility) => facility._id === facilityId)) {
                realFacilities.push(facilityId);
            }
            return null;
        });
        return realFacilities;
    };

    loadGridData = () => {
        abortApiCalls();
        releaseApiCalls();
        this.gridApi.showLoadingOverlay();
        let searchFilters = this.state.searchFilters;
        searchFilters.facility_id = this.checkRealFacilities(searchFilters);
        searchFilters.testIds = this.state.testIds;
        searchFilters.includeArchived = this.state.isArchived;
        getRequisitions(searchFilters).then((response) => {
            const rowData = Array.isArray(response?.data) ? response.data : [];
            this.setState({ rowData });
            if (!rowData.length) {
                this.gridApi.showNoRowsOverlay();
            } else {
                this.gridApi.hideOverlay();
            }
        });
    };

    onIsArchivedInformation = (event) => {
        this.setState({ isArchived: event.target.checked });
        this.loadFacilities(event.target.checked);
    };

    onIsReducedGridView = (event) => {
        this.setState({ isReducedGridView: event.target.checked });
        this.loadFacilities(this.state.isArchived);
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    createRequisition = () => {
        if (
            this.state.facilities &&
            this.state.facilities.length &&
            this.state.facilities.filter((item) => item.archived !== "archived").length
        ) {
            this.setState({ showCreateToxicologyRequisition: true }, () => {
                let elements = document.getElementsByClassName("removeTabIndexModal");
                if (elements.length) {
                    for (let i = 0; i < elements.length; i++) {
                        let dialog = elements[i];
                        dialog.parentNode.removeAttribute("tabindex");
                    }
                }
            });
        } else {
            toastr.info("You need to have active facilities to make requisition.");
        }
    };

    handleCloseCreateToxicologyRequisition = () => {
        this.setState({ showCreateToxicologyRequisition: false });
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: "Requisition_Grid_" + moment().format("YYYY_MM_DD_HH_mm_ss") + ".xlsx",
            sheetName: "Requisitions"
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.RequisitionGridExported,
            user_id: userData._id,
            user_name: userData.user_name + " (" + userData.role + ")",
            update_string: auditEnums.EVENTTYPES.RequisitionGridExported
        };
        createAudit(auditData);
    };

    onBtnExportZipForRequisitions = () => {
        let pdfArray = [];
        this.gridApi.forEachNodeAfterFilter((node) => {
            if (node.data.requisition_pdf_path) {
                pdfArray.push("/files/requisitionPDF/" + node.data.requisition_pdf_path);
            }
        });
        if (pdfArray.length) {
            if (pdfArray.length > 1000) {
                toastr.warning("Maximum limit of 1000 reached.  Please reduce date range.");
            } else {
                const params = {
                    pdfArray: pdfArray,
                    userId: window.localStorage.getItem("USER_ID"),
                    type: "requisitionPDF"
                };
                boundActions.startBlockUILoading();
                bulkDownloadZipForPDF(params)
                    .then((response) => {
                        boundActions.endBlockUILoading();
                        if (response.data && response.data.RESULT === "SUCCESS") {
                            window.open(serviceConstants.HOST_NAME + response.data.path);
                        }
                    })
                    .catch((error) => {
                        boundActions.endBlockUILoading();
                        console.log(error);
                    });
            }
        } else {
            toastr.warning("There is no item has requisition pdf file");
        }
    };

    onPageSizeChanged = () => {
        let value = document.getElementById("page-size").value;
        this.setState({ paginationPageSize: Number(value) });
    };

    loadGridSchema = () => {
        let userId = window.localStorage.getItem("USER_ID");
        let params = {
            user_id: userId,
            type: settingConstants.GRID,
            page: settingConstants.REQUISITIONS
        };
        getViewSettings(params).then((response) => {
            const columnState =
                response.data &&
                response.data.length > 0 &&
                response.data[0].grid_views.find((item) => {
                    return item.name === this.state.gridName;
                }).columns;
            if (columnState) {
                this.gridApi.applyColumnState({
                    state: columnState,
                    applyOrder: true
                });
            } else {
                this.gridApi.resetColumnState();
            }

            const pageSize =
                response.data &&
                response.data.length > 0 &&
                response.data[0].grid_views.find((item) => {
                    return item.name === this.state.gridName;
                }).page_size;
            document.getElementById("page-size").value = pageSize && pageSize > 0 ? pageSize : 20;
            this.onPageSizeChanged();
        });
    };

    saveState = () => {
        let userId = window.localStorage.getItem("USER_ID");
        const columnState = this.gridApi.getColumnState();
        let pageSize = document.getElementById("page-size").value;
        let saveObject = {
            user_id: userId,
            type: settingConstants.GRID,
            page: settingConstants.REQUISITIONS,
            grid_views: [
                {
                    name: this.state.gridName,
                    page_size: pageSize,
                    columns: columnState
                }
            ]
        };
        saveViewDefault(saveObject).then(() => {
            toastr.success("Saved successfully.");
        });
    };

    resetState = () => {
        this.gridApi.resetColumnState();
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: "" });
        document.getElementById("reset-form").value = "";

        const filters = this.state.searchFilters;

        filters.from_date = moment().format("YYYY-MM-DD") + "T00:00";
        filters.to_date = moment().add(1, "days").format("YYYY-MM-DD") + "T00:00";
        if (this.state.facilities.length > 1) {
            filters.facility_id = this.facilityIds;
        } else {
            filters.facility_id = this.state.facilities[0]._id;
        }
        window.localStorage.removeItem("FACILITY_ID");
        window.localStorage.removeItem("FROM_DATE_RANGE");

        this.setState({ searchFilters: filters, testIds: this.testIds });
        this.loadGridData();
        this.setDateRange(filters);
    };

    releaseSelectedItems = (orderIds) => {
        releaseResults({ orderIds: orderIds }).then((res) => {
            if (res && res.success) {
                toastr.success("Released successfully");
                this.loadGridData();
            } else {
                toastr.error("Something went wrong");
            }
        });
    };

    bulkRelease = () => {
        const selectedNodes = this.gridApi.getSelectedNodes();
        const selectedRows = selectedNodes.map((node) => node.data);
        if (selectedRows.length === 0) {
            toastr.warning("No order selected.");
            return;
        }
        if (selectedRows.find((item) => !["Pending Review", "On Hold"].includes(item.status))) {
            toastr.warning("Release can be done for 'Pending Reivew' and 'On Hold' status orders");
        } else {
            this.releaseSelectedItems(selectedRows.map((item) => item._id));
        }
    };

    render() {
        let columnDefs = this.state.columnDefs;
        const { isReducedGridView } = this.state;
        if (/audit/.test(getUserRole().toLowerCase())) {
            columnDefs = columnDefs.filter((item) => item.headerName !== "Actions");
        }
        columnDefs = /salesperson|salesadmin/.test(getUserRole().toLowerCase())
            ? columnDefs[2].children.filter((x) =>
                  /Patient Name|Sample ID|Facility|Physician|Collected Date|Collector Name/.test(x.headerName)
              )
            : columnDefs;

        if (isReducedGridView && isAllowedReducedGridView("requisition")) {
            columnDefs = [
                columnDefs[0],
                columnDefs[1],
                ...columnDefs[2]?.children.filter(
                    (x) =>
                        /Requisition|Status|Patient Name|Test|Specimen Type|Sample|Requisition PDF|Result PDF|Facility|Physician|Specimen Collected Date/.test(
                            x.headerName
                        ) && !/Sample Tracking/.test(x.headerName)
                )
            ];
            columnDefs[columnDefs.length - 1]["resizable"] = false;
        }

        let filteredRowData = this.state.rowData.filter(
            (item) =>
                this.state.selectedStatuses.includes(item.status) || (this.state.isArchived && item.status === "Archived")
        );

        return (
            <div className="clinic-contain">
                <RequisitionGridContext.Provider
                    value={{
                        isReducedGridView,
                        onIsReducedGridView: this.onIsReducedGridView
                    }}
                >
                    <RequisitionSearchMenu
                        onIsArchivedInformation={(event) => {
                            this.onIsArchivedInformation(event);
                        }}
                        isArchived={this.state.isArchived}
                        facilityId={this.state.searchFilters.facility_id}
                        handleFiltersChange={this.handleFiltersChange}
                        handleDateFiltersChange={this.handleDateFiltersChange}
                        updateDateRange={this.updateDateRange}
                        selectedStatuses={this.state.selectedStatuses}
                        facilities={this.state.facilities}
                        from_date={this.state.searchFilters.from_date}
                        to_date={this.state.searchFilters.to_date}
                        date_range={this.state.searchFilters.dateRange}
                        onFilterTextChange={this.onFilterTextChange}
                        clearFilter={this.clearFilter}
                        onPageSizeChanged={this.onPageSizeChanged}
                        saveState={this.saveState}
                        resetState={this.resetState}
                        onBtnExport={this.onBtnExport}
                        createRequisition={this.createRequisition}
                        user_role={this.state.user_role}
                        onBtnExportZipForRequisitions={this.onBtnExportZipForRequisitions}
                        tests={this.state.tests}
                        testIds={this.state.testIds}
                        bulkRelease={this.bulkRelease}
                    />
                </RequisitionGridContext.Provider>
                <CreateToxicologyRequisition
                    show={this.state.showCreateToxicologyRequisition}
                    handleClose={this.handleCloseCreateToxicologyRequisition}
                    context={this.state.context}
                />
                <div
                    style={{
                        width: "100%",
                        height: "calc(100vh - 350px)",
                        padding: "15px"
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: "100%",
                                    width: "100%"
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    rowData={filteredRowData}
                                    components={this.state.components}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    paginationNumberFormatter={this.state.paginationNumberFormatter}
                                    paginationPageSizeSelector={false}
                                    excelStyles={this.state.excelStyles}
                                    context={this.state.context}
                                    processCellForClipboard={processCellForClipboard}
                                    defaultExcelExportParams={defaultExcelExportParams}
                                    rowClassRules={this.state.rowClassRules}
                                    theme={themeName === "Light" ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                    rowSelection="multiple"
                                    getRowId={(params) => params.data._id}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default ToxicologyOrderGrid;
